import React from 'react';
import AIIcon from '../svg/ai.svg';

const IconAI = () => (
  <img src={AIIcon} alt="AI Icon" width={76} height={76} style={{ margin: '-6px 0' }} />
);

export default IconAI;
